import { render, staticRenderFns } from "./logout_shssc.vue?vue&type=template&id=e482770c&scoped=true"
import script from "./logout_shssc.vue?vue&type=script&lang=js"
export * from "./logout_shssc.vue?vue&type=script&lang=js"
import style0 from "./logout_shssc.vue?vue&type=style&index=0&id=e482770c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e482770c",
  null
  
)

export default component.exports